import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { InferType } from "yup";
import { createStaffInfoValidationForm } from "../../utils/validationSchemas";

//@ts-ignore
import { FormLayout } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import StaffForm from "./StaffForm";

const CreateStaffInfo = (props: any) => {
  const { handleCreate, isLoading, setOpenUserFormPopup, openUserFormPopup } = props;

  const [showLocationAlert, setShowLocationAlert] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    control,
    watch,
    clearErrors,
  } = useForm<InferType<typeof createStaffInfoValidationForm>>({
    resolver: yupResolver(createStaffInfoValidationForm),
    defaultValues: {
      latitude: null,
      longitude: null,
      location_name: ""
    }
  });
  
  const fetchLocationName = async (latitude: number, longitude: number) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
      );
      const data = await response.json();
      if (data.display_name) {
        setValue("location_name", data.display_name);
      }
    } catch (error) {
      console.error("Error fetching location name", error);
    }
  };

useEffect(() => {
  const handleLocationSecurity = async () => {
    if (!navigator.permissions || !navigator.geolocation) {
      console.warn("Location or Permissions API is not supported by this browser.");
      return;
    }

    try {
      const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });

      const triggerGps = () => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            
            setValue("latitude", latitude, { shouldValidate: true });
            setValue("longitude", longitude, { shouldValidate: true });
            clearErrors(["latitude", "longitude"]);
            
          
            fetchLocationName(latitude, longitude);
            
            setShowLocationAlert(true);
            setTimeout(() => setShowLocationAlert(false), 4000);
          },
          (error) => {
            if (error.code === error.PERMISSION_DENIED) {
              alert("Location Access Denied! Please enable location permissions in your browser settings to auto-fill the address.");
            }
          },
          { enableHighAccuracy: true, timeout: 15000 }
        );
      };
      if (permissionStatus.state === 'granted') {
        triggerGps();
      } else if (permissionStatus.state === 'prompt') {
        if (window.confirm("This site requires location access to auto-fill coordinates. Would you like to enable it?")) {
          triggerGps();
        }
      } else if (permissionStatus.state === 'denied') {
        console.warn("Location access is denied at the browser level.");
 
      }

      permissionStatus.onchange = () => {
        if (permissionStatus.state === 'granted') {
          triggerGps();
        }
      };

    } catch (err) {
      console.error("Error checking permissions:", err);
    }
  };
  const timer = setTimeout(handleLocationSecurity, 1200);
  
  return () => clearTimeout(timer);
}, [setValue, clearErrors]);
  return (
   <div className={tw`relative`}>
      {showLocationAlert && (
        <div className={tw`fixed top-5 right-5 z-[9999] bg-green-500 text-white px-6 py-4 rounded-xl shadow-2xl flex items-center gap-3 animate-bounce`}>
          <span className={tw`text-xl`}>📍</span>
          <div>
            <p className={tw`font-bold`}>Location Detected</p>
            <p className={tw`text-xs text-green-100`}>All fields auto-filled successfully.</p>
          </div>
        </div>
      )}

      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Create"}
        isLoading={isLoading}
      >
        <StaffForm
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          isEdit={false}
          control={control}
          watch={watch}
          setOpenUserFormPopup={setOpenUserFormPopup}
          openUserFormPopup={openUserFormPopup}
        />
      </FormLayout>
    </div>
  );
};

export default CreateStaffInfo;